import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import { styled, Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import Typography from '@mui/material/Typography'
import { ReactComponent as DeleteIcon } from '../../../icon/backoffice_delete.svg'

type DeleteActionProps = {
    data: any
    variant?: 'text' | 'outlined' | 'contained'
    size?: 'small' | 'medium' | 'large'
    onClick?: (data: any) => void
}
const DeleteAction = (props: DeleteActionProps) => {
    const { t } = useTranslation()
    const classes = useStyles()

    return (
        <Button
            variant={props.variant}
            size={props.size}
            color="error"
            onClick={() => props.onClick?.(props.data)}
            classes={{ root: classes.button }}
        >
            <IconDelete />
            <StyledTypo>{t('BUTTON.DELETE')}</StyledTypo>
        </Button>
    )
}

export default DeleteAction

const useStyles = makeStyles((theme: Theme) => ({
    button: {
        padding: '5px 0px !important',
    },
}))

const StyledTypo = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    marginLeft: '5px',
    fontWeight: 'bold',
    color: theme.palette.getContrastText('required'),
}))

const IconDelete = styled(DeleteIcon)(({ theme }) => ({
    height: '14px',
    fill: theme.palette.getContrastText('required'),
}))
